var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgReceivables = function SvgReceivables(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.578,
    height: 20.037,
    viewBox: "0 0 21.578 20.037",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69876",
    "data-name": "Group 69876",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1219",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1191",
    d: "M7.262-31a2.943,2.943,0,0,0-2.685,1.744L2.066-23.607A.688.688,0,0,0,2-23.294v6.165a2.324,2.324,0,0,0,2.312,2.312H21.266a2.324,2.324,0,0,0,2.312-2.312v-6.165a.8.8,0,0,0-.067-.313Q22.255-26.43,21-29.256A2.942,2.942,0,0,0,18.316-31H16.642a.771.771,0,0,0-.771.771.771.771,0,0,0,.771.771h1.674a1.393,1.393,0,0,1,1.276.829l2.029,4.565H18.03a1.967,1.967,0,0,0-1.79,1.157l-.756,1.677a.417.417,0,0,1-.384.248H10.477a.417.417,0,0,1-.384-.248l-.756-1.677a1.967,1.967,0,0,0-1.79-1.157H3.957l2.029-4.565a1.393,1.393,0,0,1,1.276-.829H8.936a.771.771,0,0,0,.771-.771A.771.771,0,0,0,8.936-31ZM3.541-22.523H7.548a.417.417,0,0,1,.384.248L8.687-20.6a1.967,1.967,0,0,0,1.79,1.157H15.1a1.967,1.967,0,0,0,1.79-1.157l.756-1.677a.417.417,0,0,1,.384-.248h4.007v5.395a.753.753,0,0,1-.771.771H4.312a.753.753,0,0,1-.771-.771Z",
    transform: "translate(-2 34.853)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1211",
    d: "M15.083-36a.771.771,0,0,0-.771.771v8.158l-1-1a.738.738,0,0,0-1.09,0,.771.771,0,0,0,0,1.09l2.312,2.312a.771.771,0,0,0,1.09,0l2.312-2.312a.771.771,0,0,0,0-1.09.771.771,0,0,0-1.09,0l-1,1v-8.158A.771.771,0,0,0,15.083-36Z",
    transform: "translate(-4.294 36)",
    fill: "#ffd45d"
  })))));
};

export default SvgReceivables;